(ns frontend.actions.role
  (:require [frontend.conn :as conn]
            [promesa.core :as p]))

(defn *->set-encryption-data [data on-success! on-error!]
  (-> (conn/sendp! :role/set-encryption-data data)
      (p/then on-success!)
      (p/catch on-error!)))

